module.exports = __webpack_public_path__ + "img/katadin.222c9659.png";